import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

// eslint-disable-next-line react/prefer-stateless-function
class UserDaysStatTable2Item extends Component {
  render() {
    return (
      <tr>
        <td>{this.props.item.groupDateDesc}</td>
        <td className="text-primary text-right">
          {this.props.item.refRegCounter}
        </td>
        <td className="text-primary text-right">
          {this.props.item.ref2RegCounter}
        </td>
        <td className="text-success text-right">
          {this.props.item.refSum} <i className="fa fa-rub" />
        </td>
      </tr>
    );
  }
}

UserDaysStatTable2Item.propTypes = {
  item: PropTypes.shape({
    groupDateDesc: PropTypes.string.isRequired,
    refRegCounter: PropTypes.number.isRequired,
    ref2RegCounter: PropTypes.number.isRequired,
    refSum: PropTypes.number.isRequired
  }).isRequired
};

export default withRouter(UserDaysStatTable2Item);



// WEBPACK FOOTER //
// ./src/components/UserDaysStat/UserDaysStatTables/UserDaysStatTable2/UserDaysStatTable2Item.js